import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { EModalIcons, EModalsNames } from 'shared/types/modal.interface';
import { smallModalPadding, smallModalClosePosition } from 'shared/constants/mui-constants';
import { ModalContainer } from '../ModalContainer';

const iconSize = { lg: '60px', md: '50px', sm: '50px', xs: '50px' };

export const PopupNotification: React.FC = () => {
  const { entityName, data } = useAppSelector(selectCurrentModal);

  const dispatch = useAppDispatch();
  const handleClose = () => dispatch(closeCurrentModal());

  if (entityName !== EModalsNames.PopUpNotification) return null;

  return (
    <ModalContainer
      isOpen={entityName === EModalsNames.PopUpNotification}
      onClose={handleClose}
      padding={smallModalPadding}
      closeIconPosition={smallModalClosePosition}
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          rowGap: { lg: '25px', md: '15px', sm: '15px', xs: '15px' },
          minHeight: { lg: '160px', md: '100px', sm: '100px', xs: '100px' },
        }}
      >
        {data.icon === EModalIcons.success && (
          <CheckCircleIcon
            sx={{
              color: 'info.dark',
              fontSize: iconSize,
            }}
          />
        )}
        {data.icon === EModalIcons.warning && (
          <InfoRoundedIcon
            sx={{
              color: 'info.contrastText',
              fontSize: iconSize,
            }}
          />
        )}
        {data.icon === EModalIcons.error && (
          <CancelIcon
            sx={{
              color: 'error.main',
              fontSize: iconSize,
            }}
          />
        )}
        <Typography variant="h2" color="primary.main" textAlign="center" textTransform="none">
          {data.title}
        </Typography>
      </Stack>
    </ModalContainer>
  );
};
